import Vue from 'vue'
import Vuex from 'vuex'

import {getAdvertiseTypeList } from '@/services/advertise.js'

Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        adTypeConfig: [],
        adTypeConfig1:[],
        list: [],
        show: false,
        LOADING: false,
    },
    mutations: {
        getAdvertise(state) {
            getAdvertiseTypeList({}).then((res) => {
                state.adTypeConfig = res;
                state.adTypeConfig1 = res.filter(item => item.visibility == 1);

            })
        },
        showLoading(state) {
            state.LOADING = true
        },
        hideLoading(state) {
            state.LOADING = false
        },
        /*
  * 设置state
  * */
        setState(state, params) {
            for (let k in params){
                state[k] = params[k]
            }
        }
    },

    actions: {
        //初始化数据
        getAd({ commit }) {
            commit('getAdvertise')
        },
        showLoading() {
            this.state.LOADING = true
        },
        hideLoading() {
            this.state.LOADING = false
        },
    }

})
